import * as React from 'react';
import { Handle, Position } from '@xyflow/react';
import { TerminalNode } from '../terminal-node/terminal-node.component';
import { floatingHandleStyles } from '../../styles/floating-handle-styles';

export const StartNode = () => (
  <>
    <TerminalNode type="start" />
    <Handle
      type="source"
      position={Position.Bottom}
      data-testid="start-node-handle"
      style={floatingHandleStyles.sourceBottom}
    />
  </>
);
